// Note:
// localePercent is used with fractional percentages (between 0 and 1 inclusive)
// For whole numbers, use the convenience method localePercentWhole

type LocaleStringOptionsT = {
  minimumFractionDigits: number
}

const localeStringDefaults = {
  minimumFractionDigits: 0,
}

const localePercent = (
  n: number,
  {minimumFractionDigits}: LocaleStringOptionsT = localeStringDefaults,
) => n.toLocaleString(undefined, {style: 'percent', minimumFractionDigits})

export function localePercentWhole(whole: number): string {
  return localePercent(whole / 100)
}
